/* istanbul ignore file */
import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { BaseDict } from "./dict";
import { config } from "./config";
import { JackpotWinningAnimationBlock } from "./ui/JackpotWinningAnimationBlock";
import { InitHelpers } from "../../helpers";
import { store } from "../../data/store";
if (InitHelpers.isDevEnv()) {
    const mocks = require("../../mocks");
    mocks.SetWindowMocks();
}
export class JackpotWinningAnimationRoot extends BaseBlock {
    // tslint:disable-next-line:cyclomatic-complexity
    constructor(domId, options = {
        dict: BaseDict,
        cms: {},
    }) {
        super(domId, options);
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
        // merge default and CMS options
        this.options.cms = Object.assign(Object.assign({}, config), (options.cms || {}));
        if (InitHelpers.isDevEnv()) {
            this.options.cms = require("../../mocks/MockedResponses").cmsJackpotWinningAnimationAll;
        }
    }
    activate() {
        return super.activate(React.createElement(JackpotWinningAnimationBlock, { cms: this.options.cms, dict: this.options.dict, store: store }));
    }
    deactivate() {
        return super.deactivate();
    }
}
window["JackpotWinningAnimation"] = JackpotWinningAnimationRoot;
broadcastBlockLoad("JackpotWinningAnimation");
//# sourceMappingURL=index.js.map